<script lang="ts">
	import { replace } from 'svelte-spa-router';

	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	import { isShellyMobileApp } from 'src/helpers/settings/settings_config_helpers';

	import AppSettingsLegacy from './AppSettingsLegacy.svelte';
	import AppSettingsV2 from './AppSettingsV2.svelte';

	// App Settings is only available inside the Shelly mobile app (per FigJam).
	// On web/desktop (incl. browser responsive mode) redirect away so the empty
	// tab is never surfaced in either layout.
	const isMobileApp = isShellyMobileApp();

	$: if (!isMobileApp) {
		replace('/settings/user');
	}
</script>

{#if isMobileApp}
	{#if $showNewLayout}
		<AppSettingsV2 />
	{:else}
		<AppSettingsLegacy />
	{/if}
{/if}
